import {  Directive, TemplateRef, Input } from '@angular/core';

@Directive({
    selector: '[filePreviewListTypeTemplate]'
})
export class FFilePreviewListTypeTemplateDirective {
    constructor(public template: TemplateRef<any>) { }
}

@Directive({
    selector: '[filePreviewToolbarTemplate]'
})
export class FFilePreviewToolbarTemplateDirective {
    constructor(public template: TemplateRef<any>) { }
}
